export const getFilters = s => s.reports.get('filters')?.toJS();
export const getReports = s => s.reports.get('reports').toJS();
export const getReportsLoading = s => s.reports.get('reportsLoading');
